export {
    default,
    type SelectionStagesSectionProps,
    SECTION_ID as selectionStagesSectionId,
} from './SelectionStagesSection';
